module.exports = __webpack_public_path__ + "static/guard_drake-923adfcf24c3032daaaaf31f85c25626.png";